import React from 'react';
import Modal from 'react-modal';
import { Box, Typography } from '@material-ui/core';

const SuccessModal = ({ open, onClose }) => {
    return (
        <Modal isOpen={open} onClose={onClose} onRequestClose={onClose} className="Modal" overlayClassName="Overlay">
            <Box display="flex" alignItems="center" minHeight={150}>
                <Typography variant="h5">Заявка в технический отдел отправлена!</Typography>
            </Box>
        </Modal>
    );
};

export default SuccessModal;
